import React, { useContext, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import SelectErp from "../../../../components/basics/SelectErp";

import { HeaderModal } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useEmissaoController from "../controllers/EmissaoController";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";

const ModalEmissaoDI = ({ modalDIOpen, setModalDIOpen }) => {
  const {
    listUf,
    diDeclarationDiNumber,
    diDeclarationDate,
    diDeclarationUf,
    diDeclarationCity,
    diDeclarationDateDes,
    diDeclarationDrawback,
  } = useContext(EmissaoContext);

  const { productError } = useContext(ParametrosProdutoContext);

  const {
    handleAddItemDi,
    diNumber,
    setDiNumber,
    diRegisterDate,
    setDiRegisterDate,
    diClearanceUf,
    setDiClearanceUf,
    diClearancePlace,
    setDiClearancePlace,
    diDateDes,
    setDiDateDes,
    diDrawback,
    setDiDrawback,
    diSequence,
    setDiSequence,
    diAdd,
    setDiAdd,
  } = useEmissaoController();

  useEffect(() => {
    setDiNumber(diDeclarationDiNumber);
    setDiRegisterDate(diDeclarationDate);
    setDiClearanceUf(diDeclarationUf);
    setDiClearancePlace(diDeclarationCity);
    setDiDateDes(diDeclarationDateDes);
    setDiDrawback(diDeclarationDrawback);
  }, [
    diDeclarationCity,
    diDeclarationDate,
    diDeclarationDateDes,
    diDeclarationDiNumber,
    diDeclarationDrawback,
    diDeclarationUf,
    setDiClearancePlace,
    setDiClearanceUf,
    setDiDateDes,
    setDiDrawback,
    setDiNumber,
    setDiRegisterDate,
  ]);

  const handleClose = () => {
    setModalDIOpen(false);
  };
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalDIOpen}
      onClose={handleClose}
      aria-labelledby="dialog-di"
    >
      <HeaderModal>
        <DialogTitle id="dialog-di">
          <Chip label="Item DI" bgcolor="primary" textcolor="white" />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item lg={2} sm={6}>
              <TextField
                value={diNumber}
                setValue={setDiNumber}
                size="small"
                label="Nº DI"
                error={productError.productDiNumber ? true : false}
                helperText={productError.productDiNumber || ""}
              />
            </Grid>
            <Grid item lg={3} sm={6}>
              <TextField
                value={diRegisterDate}
                setValue={setDiRegisterDate}
                type="date"
                size="small"
                label="Data Registro"
                error={productError.productDiRegisterDate ? true : false}
                helperText={productError.productDiRegisterDate || ""}
              />
            </Grid>
            <Grid item lg={2} sm={6}>
              <SelectErp
                label="UF Desembaraço"
                value={diClearanceUf}
                setValue={setDiClearanceUf}
                optionsList={listUf}
                descriptionField="estado"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                error={productError.productDiClearanceUf ? true : false}
                helperText={productError.productDiClearanceUf || ""}
              />
            </Grid>
            <Grid item lg={5} sm={6}>
              <TextField
                value={diClearancePlace}
                setValue={setDiClearancePlace}
                size="small"
                label="Local Desembaraço"
                error={productError.productDiClearancePlace ? true : false}
                helperText={productError.productDiClearancePlace || ""}
              />
            </Grid>
            <Grid item lg={3} sm={6}>
              <TextField
                value={diDateDes}
                setValue={setDiDateDes}
                size="small"
                type="date"
                label="Data Desembaraço"
                error={productError.productDiDateDes ? true : false}
                helperText={productError.productDiDateDes || ""}
              />
            </Grid>
            <Grid item lg={3} sm={6}>
              <TextField
                value={diDrawback}
                setValue={setDiDrawback}
                size="small"
                label="Nº Drawback"
              />
            </Grid>
            <Grid item lg={3} sm={6}>
              <TextField
                value={diSequence}
                setValue={setDiSequence}
                size="small"
                label="Nº Sequência"
                error={productError.productDiSequence ? true : false}
                helperText={productError.productDiSequence || ""}
              />
            </Grid>
            <Grid item lg={3} sm={6}>
              <TextField
                value={diAdd}
                setValue={setDiAdd}
                size="small"
                label="Nº Adição"
                error={productError.productDiAdd ? true : false}
                helperText={productError.productDiAdd || ""}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn onClick={() => handleAddItemDi(setModalDIOpen)} label="incluir" />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoDI;
